<template>
 <!-- Main content -->
 <section class="content">
   <!-- Indicadores Gerais -->
    <categoria-indicadores
      titulo="Indicadores gerais dos reatores"
      :ids="categorias.indicadoresGerais"
      :registros="registros"
      :idioma="idioma" />

    <!-- Indicadores Biológicos -->
    <categoria-indicadores
      titulo="Indicadores biológicos"
      :ids="categorias.indicadoresBiologicos"
      :registros="registros"
      :idioma="idioma" />

      <!-- Indicadores do Biogás -->
    <categoria-indicadores
      titulo="Indicadores Awite"
      :ids="categorias.indicadoresAwite"
      :registros="registros"
      :idioma="idioma" />

    <!-- Indicadores do Biogás -->
    <categoria-indicadores
      titulo="Indicadores do biogás no Biodigestor (Sistema Awite)"
      :ids="categorias.indicadoresBiogasAwiteBiodigestor"
      :registros="registros"
      :idioma="idioma" />
      
    <!-- Indicadores do Biogás -->
    <categoria-indicadores
      titulo="Indicadores do biogás na Lagoa (Sistema Awite)"
      :ids="categorias.indicadoresBiogasAwiteLagoa"
      :registros="registros"
      :idioma="idioma" />

    <!-- Indicadores do Biogás -->
    <categoria-indicadores
      titulo="Indicadores do biogás no Ponto de Consumo (Sistema Awite)"
      :ids="categorias.indicadoresBiogasAwitePontoConsumo"
      :registros="registros"
      :idioma="idioma" />
 </section>
 
 <!-- /.content -->
</template>

<script>
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'
import config from '../../config'
import VAChart from '../widgets/VAChart'
import CategoriaIndicadores from '../widgets/CategoriaIndicadores'

var db = firebaseApp.database()

export default {
  name: 'Dashboard',
  mixins: [Vue2Filters.mixin],
  components: {
    'va-chart': VAChart,
    'categoria-indicadores': CategoriaIndicadores
  },
  mounted () {
    if (config.exibirGraficoInicial) {
      this.efetuarPesquisa()
    }
  },
  methods: {
    efetuarPesquisa: function () {
      this.pesquisa.parametro = config.grafico.parametro
      this.pesquisa.titulo = config.grafico.titulo
      this.pesquisa.label = config.grafico.label
      this.$store.dispatch('createGraficoSeteDias', this.pesquisa)
      .then(response => {
        this.seteDiasGrafico = response.data.grafico
        this.tituloGrafico = response.data.titulo
        this.exibirGrafico = true
      })
      .catch(e => {
        this.errors.push(e)
      })
    }
  },
  data () {
    return {
      registros: [],
      idioma: config.idioma,
      pesquisa: {
        titulo: '',
        parametro: '',
        label: ''
      },
      tituloGrafico: '',
      seteDiasGrafico: {},
      exibirGrafico: false,
      categorias: {
        indicadoresGerais: ['BiodigestorNivel', 'BiodigestorPressao', 'BiodigestorTempBio', 'ReceptorNivel', 'ReceptorTemperatura'],
        indicadoresBiologicos: ['BiodigestorQualidadeFosTac', 'BiodigestorQualidadePh', 'ReceptorQualidadeFosTac', 'ReceptorQualidadePh'],
        indicadoresBiogasAwiteBiodigestor: ['AwitePt1Metano', 'AwitePt1CO2', 'AwitePt1H2S', 'AwitePt1O2'],
        indicadoresBiogasAwiteLagoa: ['AwitePt2Metano', 'AwitePt2CO2', 'AwitePt2H2S', 'AwitePt2O2'],
        indicadoresAwite: ['AwitePt5TempAwiFlow', 'AwitePt5AbsHumidityAwiFlow', 'AwitePt5CurrentFlowUncompensated', 'AwitePt5CurrentFlowCompensated', 'AwitePt5VolumeCounter', 'AwitePt5CurrentCalorificValue', 'AwitePt5AverageCalorificValue', 'AwitePt5CurrentEnergyFlow', 'AwitePt5EnergyCounter', 'AwitePt5VolumeCounterDay'],
        indicadoresBiogasAwitePontoConsumo: ['AwitePt3Metano', 'AwitePt3CO2', 'AwitePt3H2S', 'AwitePt3O2']
      }
    }
  },
  firebase: {
    registros: db.ref(config.project)
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?31d81459